import React from 'react'
import ContactForm from '../components/contact/contact-form'

const Home2 = () => {
  return (
    <main className='space-y-20 xl:space-y-40 mb-20 xl:mb-40'>

        <section className='relative min-h-dvh'>
            <div className='relative z-20 w-full h-full container py-10 md:py-20 flex flex-col items-center space-y-10'>
              
            <div>
              <h1 className="text-3xl text-center font-bold text-white">Brace yourselves, peppol is coming.</h1>
              <p className='text-white text-center'>Jan. 2026</p>
            </div>
             

            <p className='text-white text-center max-w-3xl w-full'>Vanaf 1 januari 2026 wordt elektronische facturatie via Peppol verplicht voor alle bedrijven in België, zowel voor B2B (business-to-business) als B2G (business-to-government). Dit voor zelfstandigen, KMO’s en grote bedrijven. Facturen in PDF-formaat of op papier zullen helaas niet langer voldoen aan de wettelijke normen.</p>
            
            <div>
              <h2 className='text-center text-xl font-bold text-white'>Starten kan vandaag nog.</h2>
              <p className='text-center text-white italic'>Eenvoudig, voordelig & 100% Belgisch</p>
            </div>
            
            <p className='text-white text-center max-w-3xl'>Ondernemer of accountant? We behouden jouw manier van werken, terwijl je volledig conform de nieuwe wetgeving facturen kan sturen en ontvangen via Peppol.</p>

            <div>
              <p className='text-center text-white font-bold'>Klaar om te starten of specifieke vragen over onze Peppol-oplossing?</p>
              <p className='text-center text-white mb-4'>Stuur ons een berichtje</p>
              <ContactForm />
            </div>

            </div>
            <div className='w-full h-full bg-black/80 absolute z-10 top-0 left-0'></div>
            <img src="/images/BraceYourselves.jpg" alt="Brace Yourself" className='absolute z-0 top-0 left-0 object-cover object-center w-full h-full' />
        </section>

        <section className='container mt-10 flex items-center flex-col text-center'>
          <h2 className='text-xl md:text-3xl font-bold'>Wat kost Peppol?</h2>
          <p>Met onze Peppol-oplossing zit je goed en ben je volledig klaar voor de toekomst.</p>

          <div className='mt-8'>
          <p className='font-bold'>25 EUR / maand</p>
          <p>Onbeperkt e-facturen sturen en ontvangen</p>

          <p className='mt-4'>Eerste 6 maanden volledig gratis</p>

          <p className='font-bold mt-4'>Eenmalige opstart:</p>
          <p>399 EUR</p>

          <p className='font-bold mt-4'>Integraties</p>
          <p>Welke applicatie je ook hebt, wij koppelen met jouw pakket</p>
          </div>
        </section>
    </main>
  )
}

export default Home2